var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscriptionSubsequentPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 55,
    viewBox: "0 0 70 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 6L25 0.226497V11.7735L35 6ZM4 38.55V16.45H2V38.55H4ZM13.45 7H24.3333V5H13.45V7ZM24.3333 7H26V5H24.3333V7ZM24.3333 48H13.45V50H24.3333V48ZM2 38.55C2 44.8736 7.12635 50 13.45 50V48C8.23091 48 4 43.7691 4 38.55H2ZM4 16.45C4 11.2309 8.23091 7 13.45 7V5C7.12634 5 2 10.1263 2 16.45H4Z",
    fill: "#A5A6A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 49L45 54.7735V43.2265L35 49ZM66 16.45V38.55H68V16.45H66ZM56.55 48H45.6667V50H56.55V48ZM45.6667 48H44V50H45.6667V48ZM45.6667 7.00002H56.55V5.00002H45.6667V7.00002ZM68 16.45C68 10.1264 62.8737 5.00002 56.55 5.00002V7.00002C61.7691 7.00002 66 11.2309 66 16.45H68ZM66 38.55C66 43.7691 61.7691 48 56.55 48V50C62.8737 50 68 44.8737 68 38.55H66Z",
    fill: "#A5A6A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionSubsequentPayment);
export default __webpack_public_path__ + "static/media/subscription_subsequent_payment.f57d2b8b2517cfd629e63c6caa95acf6.svg";
export { ForwardRef as ReactComponent };